import BlogForm from "../component/BlogForm";

const BlogEdit = () => {
  return <BlogForm isEditMode={true} />;
};

export default BlogEdit;
